import React from 'react';
import { X } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Button, Divider, Popover, Typography, useTheme } from '@mui/material';

const exitIcon = <X style={iconSize(28)} />;

function ActivateSchedulePopup({ isOpen, onClose, onApprove }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: theme.palette.colors.neutrals[900],
        opacity: 0.3,
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1206,
        visibility: isOpen ? 'visible' : 'hidden',
      }}>
      test
      <Popover
        onClick={e => e.stopPropagation()}
        open={Boolean(isOpen)}
        transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
        onClose={onClose}>
        <Box sx={{ padding: '32px 32px 16px' }}>
          <Button onClick={onClose} sx={{ position: 'absolute', right: '12px', top: '12px' }}>
            {exitIcon}
          </Button>

          <Typography variant="h5" sx={{ mb: '16px' }}>
            Content Access Change
          </Typography>
          <Typography variant="caption" sx={{ maxWidth: '605px', display: 'block', fontSize: '16px' }}>
            You are activating a report that was scheduled by another user. The content of this report will be filtered according to your
            content permissions. This might change the data included in the export.
            <br />
            <br />
            Are you sure you want to proceed?
          </Typography>

          <Divider sx={{ mt: '40px', mb: '16px' }} />

          <Box sx={{ ...flex.justifyEndCenter, gap: 2 }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={onApprove}>
              Continue
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
}

export default ActivateSchedulePopup;
